import React from "react";
import { Link } from "react-router-dom";
import logoBig from '../../assets/logo/logo-light-lg.png';
import {FooterWrapper} from "./Footer.styles";



const Footer = () => {

    return(
        <FooterWrapper>
            <div className={"footerInside"}>
                <Link to="/">
                    <img src={logoBig} alt="logo" className="footer-logo" />
                </Link>
                <div className={"linksDiv"}>
                   <Link to="/draft-modes" className="footer-link">Mock Draft Simulator</Link>
                    <Link to="/draft-value-chart" className="footer-link">Draft Value Chart</Link>
                    <Link to="/players" className="footer-link">Players</Link>
                    <Link to="/team-needs" className="footer-link">Team Needs</Link>
                </div>
                <div className={"inputDiv"}>
                    <input type={"email"} placeholder={"Email address"} />
                    <div className={"inputDescription"}></div>
                    <button>Subscribe</button>
                </div>
            </div>
        </FooterWrapper>
    )
}

export default Footer;